import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['cta'];

  select(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    if (ev.target.classList.contains('mr-1'))
      return;

    Array.from(document.querySelectorAll('.--times-btn')).forEach(btn => {
      btn.classList.remove('mr-1');
    });

    Array.from(document.querySelectorAll('.--times-cta')).forEach(btn => {
      if (btn.classList.contains('opacity-100')) {
        btn.classList.remove('opacity-100', 'w-1/2');

        setTimeout(() => {
          btn.classList.remove('relative');
        }, 300);
      }
    });

    ev.target.classList.add('mr-1');

    this.ctaTarget.classList.add('opacity-100', 'w-1/2', 'relative');
  }
}
